interface SkeletonProps {
  className?: string;
  /** ARIA-Label für Screen-Reader (Default: "Laedt"). */
  label?: string;
}

/**
 * Pulsierender Platzhalter. Sehr bewusst kein Spinner - Skeleton-Loader
 * reduziert wahrgenommene Wartezeit (siehe Material Design "perceived
 * performance").
 *
 * Klassen sollten Hoehe/Breite via Tailwind setzen, z.B. `h-4 w-32`.
 */
export function Skeleton({ className, label = 'Lädt' }: SkeletonProps): JSX.Element {
  return (
    <span
      role="status"
      aria-label={label}
      className={[
        'inline-block animate-pulse rounded bg-surface-2',
        className ?? 'h-4 w-full',
      ].join(' ')}
    />
  );
}

/**
 * Convenience: mehrere Skeleton-Zeilen, z.B. für eine Tabelle.
 */
export function SkeletonRows({
  rows = 5,
  cols = 4,
}: {
  rows?: number;
  cols?: number;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-2" aria-busy="true">
      {Array.from({ length: rows }).map((_, ri) => (
        <div key={ri} className="flex gap-3">
          {Array.from({ length: cols }).map((__, ci) => (
            <Skeleton
              key={ci}
              className={['h-5', ci === 0 ? 'w-1/4' : 'w-1/6'].join(' ')}
              label={ri === 0 && ci === 0 ? 'Lädt Tabelle' : 'Platzhalter'}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
